import {Plan, LidType} from 'types'
import {VaultSize} from "./vaultSize"
import {validSizes as stockVaultSizes} from '../../features/vault/stockVaultStateFactory'

export const getVaultSize = (plan: Plan, ignoreVaultAbsence: boolean): VaultSize => {
    const vault = plan.vault

    if (!ignoreVaultAbsence && !vault) {
        return {
            width: 0,
            length: 0,
            height: 0,
            left: 0,
            x: 0,
            right: 0,
            front: 0,
            y: 0,
            back: 0,
            clearMeasureLeft: 0,
            clearMeasureRight: 0,
            clearMeasureFront: 0,
            clearMeasureBack: 0
        }
    }
    return {
        width: plan.width + 2 * plan.wallWidth,
        length: plan.length + 2 * plan.wallWidth,
        height: vault?.height ?? 0,
        left: -plan.wallWidth,
        x: -plan.wallWidth,
        right: plan.length + plan.wallWidth,
        front: -plan.wallWidth,
        y: -plan.wallWidth,
        back: plan.width + plan.wallWidth,
        clearMeasureLeft: 0,
        clearMeasureRight: plan.length,
        clearMeasureFront: 0,
        clearMeasureBack: plan.width,
    }
}

export const getStockVaultDimensions = (): { length: number; width: number }[] =>
    stockVaultSizes.map((size: string) => {
        const [lengthStr, widthStr] = size.split('x')
        return {
            length: parseInt(lengthStr, 10),
            width: parseInt(widthStr, 10),
        }
    })

export const getVaultPresetDimensions = (plan: Plan): { length: number; width: number }[] => {
    const lidType: LidType = plan.lid ? plan.lid.type : 'B125'
    switch (lidType) {
        case 'A15':
        case 'B125':
        case 'subfloor':
            return [
                {length: 100, width: 100},
                {length: 150, width: 100},
                {length: 200, width: 100},
                {length: 250, width: 100},
                {length: 300, width: 100},
            ]

        case 'D400':
        case 'E600':
            return [
                {length: 100, width: 100},
                {length: 150, width: 100},
                {length: 200, width: 100},
                {length: 260, width: 100},
                {length: 310, width: 100},
            ]

        default:
            return []
    }
}
